import { FormValues, getValue, InputFormGroup } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Fields as TagDetailsFields, TagsEditPanel } from "../../components/TagsEditPanel/TagsEditPanel";
import { useOperation } from "../../hooks/useOperation";
import { OperationActionProps } from "../OperationTypes";
import { ExaVmClusterUpdateTagsProps, newExaVmClusterUpdateTags } from "./ExaVmClusterUpdateTags";

export interface ExaVmClusterEditTagsProps extends OperationActionProps {
    vmClusterId: string | undefined;
    defaultTags?: { name: string; value: string; }[];
  }

const ExaVmClusterEditTags = (
  { targetId, location, vmClusterId, defaultTags, onExecute, onCancel }: ExaVmClusterEditTagsProps,
): JSX.Element => {
  const { trigger: triggerUpdateTags } = useOperation<ExaVmClusterUpdateTagsProps>(newExaVmClusterUpdateTags);
  return (
    <TagsEditPanel
      targetId={targetId}
      title={Messages.labels.editTags()}
      tagsDefaultValue={defaultTags || []}
      onSubmit={(formValues: FormValues) => {
        const tags: { name: string; value: string; }[] = getValue(formValues, TagDetailsFields.Tags, InputFormGroup);
        triggerUpdateTags({
          vmClusterId,
          tags,
          location,
          onExecute,
        });
      }}
      onClose={onCancel}
    />
  );
};

export const newExaVmClusterEditTags = (
  props: ExaVmClusterEditTagsProps,
): JSX.Element => (<ExaVmClusterEditTags {...props} />);
